<template>
  <v-row>
    <v-col cols="4" class="pr-2">
      <v-autocomplete
        v-model="domicileRegion"
        label="Region*"
        :items="domicileRegionList"
        color="companyPrimary"
        :outlined="outlined"
        dense
        :loading="isFieldLoading"
        autocomplete="null"
        @change="emitDomicileRegion"
      />
    </v-col>
    <v-col cols="4" class="pr-2">
      <v-autocomplete
        ref="domicileProvinceRef"
        v-model="domicileProvince"
        label="Province*"
        :items="domicileProvinceList"
        color="companyPrimary"
        :outlined="outlined"
        dense
        :disabled="domicileRegion === null"
        :loading="isFieldLoading"
        autocomplete="null"
        @change="emitDomicileProvince"
      />
    </v-col>
    <v-col cols="4">
      <v-autocomplete
        v-model="domicileMunicipality"
        label="Municipality*"
        :items="domicileMunicipalityList"
        color="companyPrimary"
        :outlined="outlined"
        dense
        :disabled="domicileProvince === null"
        autocomplete="null"
        @change="emitDomicileMunicipality"
      />
    </v-col>
  </v-row>
</template>

<script>
import { DomicileService } from "@/services";

export default {
  name: "BaseDomicileInfoEdit",
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    domicileInput: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    "domicile-region",
    "domicile-province",
    "domicile-municipality",
    "domicile-municipality-list",
    "domicile-province-list",
    "domicile-region-list",
  ],
  data() {
    return {
      domicileRegion: null,
      domicileRegionList: [],
      domicileProvince: null,
      domicileProvinceList: [],
      domicileMunicipality: null,
      domicileMunicipalityList: [],
    };
  },
  watch: {
    domicileRegion(newValue) {
      if (!newValue) return;
      this.getProvinceLabels(newValue);
      if (this.domicileMunicipalityList.length !== 0) {
        this.domicileMunicipality = null;
        this.domicileMunicipalityList = [];
      }
    },
    domicileProvince(newValue) {
      if (!newValue) return;
      this.getMunicipalityLabels(newValue);
    },
  },
  created() {
    this.getRegionsLabels();
    if (this.domicileInput !== null) {
      this.domicileRegion = this.domicileInput.domicileRegion;
      this.domicileProvince = this.domicileInput.domicileProvince;
      this.domicileMunicipality = this.domicileInput.domicileMunicipality;
    }
  },
  methods: {
    async getRegionsLabels() {
      this.isFieldLoading = true;
      if (this.isFieldLoading) {
        const data = await DomicileService.getAllRegions();

        this.domicileRegionList = data.map((elem) => {
          return { value: elem.id, text: elem.name };
        });
        this.isFieldLoading = false;
      }
    },
    async getProvinceLabels(region) {
      this.isFieldLoading = true;
      if (this.isFieldLoading) {
        const data = await DomicileService.getProvinceForRegion(region);

        this.domicileProvinceList = data.map((elem) => {
          return { value: elem.id, text: elem.name };
        });
        this.isFieldLoading = false;
      }
    },
    async getMunicipalityLabels(province) {
      this.isFieldLoading = true;
      if (this.isFieldLoading) {
        const data = await DomicileService.getMunicipalityInProvince(province);

        this.domicileMunicipalityList = data.map((elem) => {
          return { value: elem.id, text: elem.name };
        });
        this.isFieldLoading = false;
      }
    },
    emitDomicileRegion() {
      this.$emit("domicile-region", this.domicileRegion);
      this.$emit("domicile-region-list", this.domicileRegionList);
    },
    emitDomicileProvince() {
      this.$emit("domicile-province", this.domicileProvince);
      this.$emit("domicile-province-list", this.domicileProvinceList);
    },
    emitDomicileMunicipality() {
      this.$emit("domicile-municipality", this.domicileMunicipality);
      this.$emit("domicile-municipality-list", this.domicileMunicipalityList);
    },
  },
};
</script>
